import React from "react";
import { Card, CardContent, Typography, Grid } from "@mui/material";

export default function KeyValueDisplay({ data }) {
    return (

                <Grid container spacing={1}>
                    {Object.entries(data).map(([key, value]) => (
                        <React.Fragment key={key}>
                            <Grid item xs={2}>
                                <Typography variant="body2" color="text.secondary">
                                    {key}
                                </Typography>
                            </Grid>
                            <Grid item xs={10}>
                                <Typography variant="body1">{value}</Typography>
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>

    );
}
